import React, { useEffect, useState, useRef } from 'react';
import axios, { API } from 'config/axios';
import {
  Grid, makeStyles, Container, Button, Typography,IconButton, useMediaQuery,  useTheme,
} from '@material-ui/core';
import VehicleList from 'common/components/vehicle_list';
import SideMenu from 'common/components/SideMenu';
import Header from 'common/components/Header';
import VerificationOverlay from 'common/components/verification_overlay';
import NoVehicle from 'common/components/vehicle_list/NoVehicle';
import GetStartedOverlay from 'views/bike_upload/common/components/GetStartedOverlay';
import AddIcon from '@material-ui/icons/Add';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import useHandleResponse from 'utils/useHandleResponse';
import { useLayoutLoadingSpinner ,useLayoutSnackbar,useLayoutState} from 'components/shared/Layout';
import { withTranslation , Router} from 'config/i18n';
import Skeleton from '@material-ui/lab/Skeleton';
import Dinero from 'dinero.js';
import { countries } from 'data/countries';
import { hotjar } from 'react-hotjar';
import getConfig from 'next/config';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
  },
  listTitle: {
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.secondary.light,
    margin: theme.spacing(2,0),
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  }
}));

interface VerificationDataType {
  time_zone: any;
  country_code: any;
  phone_code: any;
  phone: any;
}

const UserVehiclesView = ({t}) => {

  const classes = useStyles();
  const {
    publicRuntimeConfig: { envVars },
  } = getConfig();
  const hotjarEnabledCheck = envVars.HOTJAR_ENABLED === 'true';
  const theme = useTheme();
  const isMediumDown = useMediaQuery(theme.breakpoints.down('md'));

  const isMounted = useRef(true);
  const [snackbar, setSnackbar] = useLayoutSnackbar();
  const { handleError } = useHandleResponse();
  const { layoutState } = useLayoutState();
  const [, setLoading] = useLayoutLoadingSpinner();
  const [states, setStates] = useState([]);
  const [vehiclesData, setVehiclesData] = useState([]);

  const [currentSelectedMenuIdentifier,setCurrentSelectedMenuIdentifier] = useState(null)

  const [openGetStartedOverlay, setOpenGetStartedOverlay] = useState(false);
  const [getStartedOverlayOpened, setGetStartedOverlayOpened] = useState(false);
  const [openVerificationOverlay, setOpenVerificationOverlay] = useState(false);


  const sideMenui18n = {
    active: t('fe_es_bikes_list:states.active'),
    "pre_approved": t('fe_es_bikes_list:states.pre_approved'),
    "inactive": t('fe_es_bikes_list:states.inactive'),
    "pending_approval": t('fe_es_bikes_list:states.pending_approval'),
    "draft": t('fe_es_bikes_list:states.draft'),
    "sent_to_insurance": t('fe_es_bikes_list:states.sent_to_insurance'),
    "rejected": t('fe_es_bikes_list:states.rejected'),
    "suspended": t('fe_es_bikes_list:states.suspended'),
  };

  const getBikesByState = (state) => {
    setLoading(true);
    setVehiclesData([])
    axios
      .get(API.userVehiclesList.vehicles,{
        params: {
          state: state,
        },
      })
      .then((res) => {
        setVehiclesData(res.data.vehicles);
        setCurrentSelectedMenuIdentifier(state);
      })
      .catch((error) => {
        handleError(error, false);
      })
      .then(() => {
        setLoading(false);
      });
  };
  const getStates = () => {
    if (process.browser) {
      setLoading(true);
      axios
        .get(API.userVehiclesList.statesCount)
        .then((res) => {
          setStates(res.data.states);

           if(!getStartedOverlayOpened) {
            const totalListingsCount = res.data.states.reduce(
              (previousValue, state) => {
                const isATargetState = ['pre_approved','draft'].findIndex((item)=> item === state.name) === -1;
                if(isATargetState) {
                  return previousValue+ state.count;
                 } else {
                  return previousValue;
                 }
              },
              0
            );
            if(totalListingsCount === 0) {
              setOpenGetStartedOverlay(true);
              setGetStartedOverlayOpened(true);
            }
          }

          if (res.data.states.filter((state) => state.name == "draft")[0].count > 0){
            getBikesByState('draft');
          } else {
            getBikesByState('active');
          }
        })
        .catch((error) => {
          handleError(error, false);
        })
        .then(() => {
          setLoading(false);
        });
    }
  };

  const handleSnackBarDisplay = (type, message ) => {
    setSnackbar({
      ...snackbar,
      open: true,
      severity: type ,
      message,
    });
  };

  const toggleBikeActivation = (url ,succesMsg ,errMsg ) => {
    setLoading(true);
    axios
      .put(url,{
        authenticity_token: layoutState.authenticity_token,
      })
      .then(() => {
        handleSnackBarDisplay('success',succesMsg);
        getStates();
      })
      .catch((err) => {
        if (err.response.status === 403) {
          handleSnackBarDisplay('error',errMsg)
        } else {
          handleError(err);
        }
      })
      .then(() => {
        setLoading(false);
      });
  };

  const [verificationData, setVerificationData] = useState<VerificationDataType>();
  const [submited, setSubmited] = useState(false);
  const [timezoneErrs, setTimezoneErrs] = useState(null);


  const checkingVerification = (btnSubmited = false) => {

    setLoading(true);
    axios
    .post(API.userVehiclesList.createDraftVehicle,{
      authenticity_token: layoutState.authenticity_token,
    })
    .then((res) => {
      if (res.data.owner.complete_profile){
        Router.push(`/user/vehicles/${res.data.vehicle.id}/main_details`);
      }
      else{
        Router.push(`/user/vehicles/${res.data.vehicle.id}/owner_details`);
      }
    })
    .catch((err) => {

      if (err.response.status === 403) {

        const resData = err.response.data.user;
        if (resData.country_code) {
          const countryCodeUpperCase = resData.country_code.toUpperCase();
          const currentPhoneCode = countries.filter((item) => item.code === countryCodeUpperCase)[0]?.phone;
          setVerificationData({
            ...resData,
            time_zones: err.response.data.time_zones,
            phone_code: currentPhoneCode,
            phone: resData.phone && resData.phone.toString().replace(`+${currentPhoneCode}`, ''),
          });
        } else {
          setVerificationData({
            ...resData,
            time_zones: err.response.data.time_zones,
            country_code: verificationData?.country_code || 'US',
            phone_code: verificationData?.phone_code || 1,
            phone:
              verificationData?.phone ||
              (resData.phone && resData.phone.toString().replace('+1', '')),
          });
        }

        if (btnSubmited && !err.response.data.user.email_verified ) {
          setSubmited(true);
          setSnackbar({
            ...snackbar,
            open: true,
            severity: 'error',
            message: t('fe_es_identity_verification:email_sent'),
          });
        } else if (btnSubmited && !err.response.data.user.phone_verified){
          setSnackbar({
            ...snackbar,
            open: true,
            severity: 'error',
            message: t('fe_es_identity_verification:phone_not_verified'),
          });
        } else if (btnSubmited && !err.response.data.user.time_zone){
          setSnackbar({
            ...snackbar,
            open: true,
            severity: 'error',
            message: t('fe_es_identity_verification:time_zone_not_verified'),
          });
        }

        setOpenVerificationOverlay(true)

      } else {
        handleError(err);
      }
    })
    .then(() => {
      setLoading(false);
    });
  }

  const verifyTimezone = (time_zone) => {
    setLoading(true);
    setTimezoneErrs(null);
    axios
      .post(API.users.verifyTimezone, {
        authenticity_token: layoutState.authenticity_token,
        timezone: time_zone || "",
      })
      .then(() => {
        checkingVerification(true);
      })
      .catch((error) => {
        try {
          switch (error.response.status) {
            case 406:
              setTimezoneErrs(error.response.data);
              break;
            default:
              handleError(error);
          }
        } catch (e) {
          handleError(error);
        }
      })
      .then(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (hotjarEnabledCheck) {
      hotjar.initialize(envVars.HOTJAR_SITE_ID, 6);
    }

    if (localStorage.getItem('flashSubmit') == 'true') {
      localStorage.removeItem('flashSubmit');
      const msg = localStorage.getItem('flashSubmitMsg');
      setSnackbar({
        ...snackbar,
        open: true,
        severity: 'success',
        message: msg || '',
      });
      localStorage.removeItem('flashSubmitMsg');

    }
    if (isMounted.current) {
      getStates();
    }
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <>
      {vehiclesData ? (
        <Header
          title={t('fe_es_bikes_list:my_bikes')}
          >
            {isMediumDown ?
              (
                <IconButton  onClick={()=>checkingVerification()}>
                  <AddCircleOutlineIcon  />
                </IconButton>
              ) : (
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<AddIcon />}
                  onClick={()=>checkingVerification()}
                >
                  {t('fe_es_bikes_list:list_new_bike')}
                </Button>
              )
            }
        </Header>
      ) : (
        <Skeleton variant="rect" width="100%" height={125} style={{ marginBottom: 16 }} />
      )}

      <Container>
        <div className={classes.root}>

          <div>
            <Grid container spacing={3}>
              <Grid item lg={3} xs={12}>
                { vehiclesData ? (
                  <>
                  <SideMenu
                    menu={states}
                    sideMenui18n={sideMenui18n}
                    hasCount='true'
                    currentSelectedMenuIdentifier={currentSelectedMenuIdentifier}
                    onTabClick={getBikesByState} />
                  <GetStartedOverlay
                    openDialog={openGetStartedOverlay}
                    setOpenDialog={setOpenGetStartedOverlay}/>
                  </>
                ) : (
                  <Skeleton variant="rect" width="100%" height={500} style={{ marginBottom: 16 }} />
                )}
              </Grid>
              <Grid item lg={9} xs={12}>
                <Typography
                  variant="h2"
                  className={classes.listTitle}
                >
                {`${sideMenui18n[currentSelectedMenuIdentifier]} ${t('fe_es_bikes_list:listings')}`}
                </Typography>
                { vehiclesData ? (
                  vehiclesData.length > 0 ? (
                    vehiclesData.map((bike) => (
                      <VehicleList
                        imgUrl={bike.image_url}
                        key={bike.image_url}
                        title={`${bike.year ? bike.year : "" } ${bike.make ? `${bike.make.name},` : ""} ${bike.model? bike.model.name:""}`}
                        price={bike.price ?(`${Dinero({
                          amount: bike.price.amount,
                          currency: bike.price.currency_code,
                        }).toFormat('$0,0.00')}`):""}
                        hourlyPrice={bike.hourly_price ?(`${Dinero({
                          amount: bike.hourly_price.amount,
                          currency: bike.hourly_price.currency_code,
                        }).toFormat('$0,0.00')}`):""}
                        state={currentSelectedMenuIdentifier}
                        location={`${bike.geography ? bike.geography.name:""}, ${bike.region ? bike.region.code:""}`}
                        listingLink={ (bike.make && bike.model && bike.geography)?
                          `/${bike.make.slug}/${bike.model.slug}/${bike.geography.slug}/${bike.id}`:""}
                        editLink={`/user/vehicles/${bike.id}/main_details`}
                        onActivate ={()=>toggleBikeActivation(
                          API.userVehiclesList.activate.replace('{id}', bike.id),
                          t('fe_es_bikes_list:activated_successfully'),
                          t('fe_es_bikes_list:already_active'))}
                        onDeactivate= {()=>toggleBikeActivation(
                            API.userVehiclesList.deactivate.replace('{id}', bike.id),
                            t('fe_es_bikes_list:deactivated_successfully'),
                            t('fe_es_bikes_list:already_inactive'))}
                      />
                    ))
                  ):(
                    <NoVehicle
                      state={sideMenui18n[currentSelectedMenuIdentifier]}
                      addingVehicle={()=>checkingVerification()}
                    />
                  )
                ) : (
                  <Skeleton variant="rect" width="100%" height={500} style={{ marginBottom: 16 }} />
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      </Container>

      {(verificationData && openVerificationOverlay) &&(
        <VerificationOverlay
          data={verificationData}
          setData={setVerificationData}
          submited={submited}
          timezoneErrs={timezoneErrs}
          continueBtnAtion={() => verifyTimezone(verificationData.time_zone)}
          openDialog={openVerificationOverlay}
          setOpenDialog={setOpenVerificationOverlay}
        />
      )}

    </>
  );
};
export default withTranslation(['fe_es_bikes_list','fe_es_identity_verification']) (UserVehiclesView);
